module.exports = __webpack_public_path__ + "assets/img/15.c10e6062.png";